import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvCarouselTransition";
/**
 * A wrapper to apply transitions between slides
 */
let LvCarouselTransition = class LvCarouselTransition extends UIComponent {
    render(h) {
        const children = this.$slots.default ?? [];
        const items = children.map((x, i) => {
            if (i == this.currentIndex) {
                return x;
            }
            else {
                return undefined;
            }
        });
        return (<div class="slides">
                <transition name={this.transitionName} appear>
                    {items}
                </transition>
            </div>);
    }
};
__decorate([
    Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], LvCarouselTransition.prototype, "currentIndex", void 0);
__decorate([
    Prop({ type: String, required: true }),
    __metadata("design:type", String)
], LvCarouselTransition.prototype, "transitionName", void 0);
LvCarouselTransition = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvCarouselTransition);
export { LvCarouselTransition };
export default LvCarouselTransition;
//# sourceMappingURL=LvCarouselTransition.jsx.map